import ButtonField from '@/components/form-control/ButtonField'
import { DATA_TABLE_STATIONS_ASSIGNMENT_SETUP } from '@/constant/common'
import { Stack, Typography } from '@mui/material'
import FooterSetup from '../../common/FooterSetup'
import MenuHeader from '../../common/MenuHeader'
import RightGoogleMapSmall from '../../common/RightGoogleMapSmall'
import SetUpLayout from '../../common/SetUpLayout'
import StationAssignmentTable from './StationAssignmentTable'

type Props = {}

const StationAssignmentData = (props: Props) => {

  const handleClick = () => {

  }

  return (
    <SetUpLayout
      title='Station Assignment'
      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMapSmall />}
      footer={<Stack p="25px 32px"><FooterSetup /></Stack>}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontSize: "20px", lineHeight: "2.4" }}>Review Station Assignment</Typography>
        <Stack alignItems="center">
          <ButtonField
            startIcon={<></>}
            style={{
              height: '32px',
              minWidth: '89px',
              borderRadius: '5px',
            }}
            name="Done"
            onClick={handleClick}
          />
        </Stack>
      </Stack>
      <StationAssignmentTable rows={DATA_TABLE_STATIONS_ASSIGNMENT_SETUP} />
    </SetUpLayout>
  )
}

export default StationAssignmentData